import { api } from "./api.v2";

export const crmGestanteService = {
  relatorioDesempenho: async (data) => {
    return api
      .get("/pdv/crm-gestante/relatorio/desempenho", { params: data })
      .then((r) => r)
      .catch((e) => e);
  },
  relatorioVendas: async (data) => {
    return api
      .get("/pdv/crm-gestante/relatorio/vendas", { params: data })
      .then((r) => r)
      .catch((e) => e);
  },
};
